import { StyledFaqAccordion } from './FaqAccordion.styled'

const FaqAccordion = ({
    children,
    heading,
    isOpen = false,
}: {
    children: React.ReactNode
    heading: string
    isOpen: boolean
}) => (
    <StyledFaqAccordion initialIsOpen={isOpen} header={heading}>
        {children}
    </StyledFaqAccordion>
)

export default FaqAccordion
